export enum RegistrationStatus {
  InitialState = 0,
  Pending = 1,
  Completed = 2
}
